import { UseQueryResult, skipToken, useQuery } from "@tanstack/react-query";
import React from "react";
import hashStringFunction from "utils/hashString";

import { DefaultEmailTemplate } from "./templates/defaultTemplate";
import { PilotEmailTemplate } from "./templates/pilotTemplate";

export const emailTemplateKeys = {
  any: ["getEmailTemplate"],
  one: ({
    linkUrl,
    companyName,
    clientName,
    clientId,
    buttonColor,
  }: {
    linkUrl: string | undefined;
    companyName: string;
    clientName: string;
    clientId: string;
    buttonColor: string | undefined;
  }) => [
    ...emailTemplateKeys.any,
    { linkUrl, companyName, clientName, clientId, buttonColor },
  ],
};

const emailTemplateClientIds: Record<string, string> = {
  "6d665ab7212c609d85d4ecd875ad1deb2c792a7cca5532ff81c528b3286d439c":
    "pilot-template",
  // mocks
  ddc20dfb29db39e18ff5bfaa9cf4314f8938dabb11afc4442e63adcfb0383d3f:
    "pilot-template",
  "mock-client-id": "pilot-template",
};

export const useGetEmailTemplate = ({
  linkUrl,
  companyName,
  clientName,
  clientId,
  buttonColor = "var(--color-ui-action)",
}: {
  linkUrl: string | undefined;
  companyName: string;
  clientName: string;
  clientId: string;
  buttonColor: string | undefined;
}): UseQueryResult<React.JSX.Element> => {
  return useQuery<React.JSX.Element>({
    staleTime: 60 * 60_000,
    queryKey: emailTemplateKeys.one({
      buttonColor,
      linkUrl,
      companyName,
      clientName,
      clientId,
    }),
    queryFn: linkUrl
      ? async () => {
          const hashedClientId = await hashStringFunction(clientId);

          const clientEmailTemplate = hashedClientId
            ? emailTemplateClientIds[hashedClientId]
            : undefined;

          if (clientEmailTemplate === "pilot-template") {
            return (
              <PilotEmailTemplate
                linkUrl={linkUrl}
                companyName={companyName}
                clientName={clientName}
                buttonColor={buttonColor}
              />
            );
          }

          return (
            <DefaultEmailTemplate
              linkUrl={linkUrl}
              companyName={companyName}
              clientName={clientName}
              buttonColor={buttonColor}
            />
          );
        }
      : skipToken,
  });
};
